import { Button, ButtonGroup, Divider, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerFooter, DrawerHeader, DrawerOverlay, HStack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form } from "components"
import { API } from "config"
import { Mask } from "config"
import moment from "moment"
import { useState } from "react"
import { ModalPassword } from "screens"

export default function Edit({ data:distributor, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({})
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()
    const auth = useDisclosure()

    const onChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            case 'doc_cnpj': setForm({...form, [name]: Mask.cnpj(value)}); break;
            case 'dob': setForm({...form, [name]: Mask.date(value)}); break;
            default: setForm({...form, [name]: value }); break;
        }
    }

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/distributors/${distributor.data?.id}`, form)
            toast({ title: 'Dados do núcleo atualizados.', status: 'info' })
            distributor.refetch()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível atualizar o núcleo', description: err?.response?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Drawer size="md" {...props}>
        <DrawerOverlay />
        <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader children={`Editar dados do núcleo`} />
            <DrawerBody>

                <Form.Form onSubmit={auth.onOpen}>

                    <Alert children="Você está prestes a editar informações sensíveis de um núcleo. Fique atento à estas alterações." status="warning" />

                    <Form.Text
                        required
                        label="Título/Nome:"
                        name="name"
                        value={form?.name}
                        error={errors?.name}
                        defaultValue={distributor.data?.name}
                        onChange={onChange}
                        isDisabled={loading}
                        size="lg"
                        fontWeight="bold"
                    />

                    <Divider />
                    <Text fontSize="small" color="GrayText" children="Dados fiscais:" />

                    <Form.Text
                        required
                        label="Razão Social:"
                        name="company_name"
                        value={form?.company_name}
                        error={errors?.company_name}
                        defaultValue={distributor.data?.company_name}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                        helper="Conforme consta no cartão cnpj da empresa."
                    />

                    <Form.Text
                        required
                        label="CNPJ:"
                        name="doc_cnpj"
                        value={form?.doc_cnpj}
                        error={errors?.doc_cnpj}
                        defaultValue={Mask.cnpj(distributor.data?.doc_cnpj)}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        required
                        label="Inscrição Estadual (IE):"
                        name="doc_ie"
                        value={form?.doc_ie}
                        error={errors?.doc_ie}
                        defaultValue={distributor.data?.doc_ie}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        required
                        label="Data de abertura da empresa:"
                        name="dob"
                        value={form?.dob}
                        error={errors?.dob}
                        defaultValue={moment(distributor.data?.dob).format('DD/MM/YYYY')}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                    />

                    <Divider />
                    <Text fontSize="small" color="GrayText" children="Dados de contato:" />

                    <Form.Text
                        required
                        type="email"
                        label="E-mail:"
                        name="email"
                        value={form?.email}
                        error={errors?.email}
                        defaultValue={distributor.data?.email}
                        onChange={onChange}
                        isDisabled={loading}
                        size="lg"
                        helper="Este e-mail será utilizado para enviar notificações importantes."
                    />

                    <Form.Text
                        required
                        label="Celular do responsável:"
                        name="mobile"
                        value={form?.mobile}
                        error={errors?.mobile}
                        defaultValue={Mask.mobile(distributor.data?.mobile)}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        required
                        label="Telefone de atendimento:"
                        name="work_number"
                        value={form?.work_number}
                        error={errors?.work_number}
                        defaultValue={distributor.data?.work_number}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                        helper="Este telefone é público e será exibido para os consultores."
                    />

                    <Divider />
                    <Text fontSize="small" color="GrayText" children="Dados de localização:" />

                    <Form.Loc defaultValue={{ city: distributor.data?.city?.id, state: distributor.data?.city?.state_id, country: distributor.data?.city?.country_id }} onChangeCity={city_id => setForm({ city_id })} isDisabled={loading} />

                    <Divider />

                    <Form.Text
                        required
                        label="Endereço (Linha 1)"
                        name="address_line_1"
                        value={form?.address_line_1}
                        error={errors?.address_line_1}
                        defaultValue={distributor.data?.address_line_1}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                    />

                    <Form.Text
                        label="Endereço (Linha 2):"
                        name="address_line_2"
                        value={form?.address_line_2}
                        error={errors?.address_line_2}
                        defaultValue={distributor.data?.address_line_2}
                        onChange={onChange}
                        isDisabled={loading}
                        size="sm"
                    />

                    <HStack>
                        <Form.Text
                            required
                            label="Bairro/Setor:"
                            name="address_neighborhood"
                            value={form?.address_neighborhood}
                            error={errors?.address_neighborhood}
                            defaultValue={distributor.data?.address_neighborhood}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            required
                            label="Código Postal (CEP):"
                            name="zip"
                            value={form?.zip}
                            error={errors?.zip}
                            defaultValue={distributor.data?.zip}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />
                    </HStack>

                    <HStack>
                        <Form.Text
                            required
                            label="Número:"
                            name="address_number"
                            value={form?.address_number}
                            error={errors?.address_number}
                            defaultValue={distributor.data?.address_number}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            required
                            label="Complemento:"
                            name="address_complement"
                            value={form?.address_complement}
                            error={errors?.address_complement}
                            defaultValue={distributor.data?.address_complement}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />
                    </HStack>

                    <Divider />

                    <HStack>
                        <Form.Text
                            label="Latitude:"
                            name="lat"
                            value={form?.lat}
                            error={errors?.lat}
                            defaultValue={distributor.data?.lat}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            label="Longitude:"
                            name="lng"
                            value={form?.lng}
                            error={errors?.lng}
                            defaultValue={distributor.data?.lng}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />
                    </HStack>

                </Form.Form>

            </DrawerBody>
            <DrawerFooter>
                <ButtonGroup size="sm" isDisabled={loading}>
                    <Button children="Atualizar dados" onClick={auth.onOpen} isLoading={loading} />
                    <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
                </ButtonGroup>
            </DrawerFooter>
        </DrawerContent>
    </Drawer>

    <ModalPassword {...auth} onSuccess={handleSubmit} />
    </>
    )
}